import{a as m}from"./chunk-M5YVNEA7.js";import{f as o,u as r}from"./chunk-Z3HBCMMX.js";import{m as a}from"./chunk-HBP5N4FR.js";a();r();var g=t=>({egldValueData:{value:t,formattedValue:m({input:t}),decimals:o}});export{g as a};
//# sourceMappingURL=chunk-UCZ44OLD.js.map
